import React from 'react';
import {
  Col, Container, Row,
} from 'react-bootstrap';

import Accordion from 'components/Accordion';
import RadioButton from 'components/DesignSystem/RadioButton';

export default function ForecastDateSelector({
  onChange,
  forecastDates,
}: {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  forecastDates: string[];
}) {
  return (
    <Accordion.Item eventKey="date-selector">
      <Accordion.Header>Data da Simulação</Accordion.Header>
      <Accordion.Body>
        <Container>
          {forecastDates.map((forecastDate) => (
            <Row key={forecastDate}>
              <Col>
                <RadioButton
                  name="forecastDate"
                  label={forecastDate}
                  onChange={onChange}
                  value={forecastDate}
                />
              </Col>
            </Row>
          ))}
        </Container>
      </Accordion.Body>
    </Accordion.Item>
  );
}
